<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone")
      .title
        span.page-title {{$t('user')}} {{$t('manage')}}

    b-row.search-form
      b-col.mmb-10
        .d-flex.align-items-center
          b-form-select.mr-2(v-model="search.val" :options="search.options" size="sm" style="width: 150px" @change="setSearchKey2")
          b-form-input(v-if="search.key.type === 'keyword'" size="sm" v-model="search.value" @keypress.enter="searchHandler")
          b-form-input(v-if="search.key.type === 'number'" size="sm" type="number" v-model="search.value" @keypress.enter="searchHandler")
          b-form-select(
            v-if="search.key.type === 'select'"
            v-model="search.value"
            :options="search.key.select"
            size="sm"
          )
          b-btn.ml-2(size="sm" variant="secondary" @click="searchHandler") {{$t('search')}}
      b-col.right-btns(v-if="!addBulk")
        b-btn(v-if="AppState.perm.isAdmin" size="sm" :to="{name: 'add-manager'}") {{$t('add_user')}}
        b-btn.ml-2(v-if="AppState.perm.isAdmin" size="sm" @click="addBulk = true") {{$t('user_page.bulk_add_users')}}
        b-btn.ml-2(v-if="AppState.perm.isAdmin && this.accountType === 1" size="sm" :to="{name: 'approver'}") {{$t('user_page.approver_management')}}
        //- b-btn(size="sm") 하위사용자 추가
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
        b-btn.ml-2.delete-btn(v-if="AppState.perm.isAdmin" variant="danger" size="sm" @click="checkedRemoteUser") {{$t('select_delete')}}
      b-col.right-btns(v-else)
        b-form-file.upload-input(ref="excelUpload" :key="excelUploadKey" size="sm")
        b-btn.ml-2(size="sm" @click="excelSubmit") {{$t('enrollment')}}
        b-btn.ml-2(
          size="sm"
          variant="info"
          :href="`${Form}/linkmemine_user_form_ko.xlsx`"
          download
        ) Excel 양식 다운로드
        //- b-btn.ml-2(size="sm", :to="{name: 'excel-add-manager-component'}") {{$t('excel-users')}}
        b-btn.ml-2(variant="danger" size="sm" @click="addBulk = false") {{$t('cancel')}}
      
    // @@@ table 관련 view
    b-card.table-card
      b-table(
        ref="userTable",
        :fields="dynamicFields",
        :items="managers",
        :current-page="page.current",
        :per-page="page.per",
        :empty-text="$t('no-content')",
        tbody-class="lmm-table-body",
        sort-by="name",
        :sort-desc="false",
        show-empty
        responsive
      )
        //- header
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @input="selectAllRows")

        //- body
        template(v-slot:cell(member_type_id)="row")
          span.member-type-icon(v-if="row.item.member_type_id === 2 || row.item.member_type_id === 3") S
          span.member-type-icon(v-if="row.item.member_type_id === 6") A

        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")

        template(v-slot:cell(mgrid)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.pk}}") {{row.item.mgrid}}
        
        template(v-slot:cell(name)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.pk}}") {{row.item.name}}
        
        template(v-slot:cell(part_name)="row")
          b-btn(v-if="user.type !== 'SubManager'" variant="link", :to="{name: 'user-edit-department', params: {id: row.item.part_pk}}") {{row.item.part_name}}
          span(v-else) {{row.item.part_name}}
        
        template(v-slot:cell(approver_name)="row")
          b-btn(variant="link", :to="{name: 'edit-manager', params: {userPk: row.item.approver_fk}}") {{row.item.approver_name}}

        template(v-slot:cell(manager)="row")
          b-btn(variant="link" @click="openDialogManager(row.item)") (#[em(:ref="`manager-${row.item.pk}`") {{ row.item.dev_current }}]/{{ row.item.mgrdev_limit }})
        
        template(v-slot:cell(agent)="row")
          b-btn(variant="link" @click="openDialogAgent(row.item)") (#[em(:ref="`agent-${row.item.pk}`") {{ row.item.agent_current }}]/{{ row.item.dev_limit }})
        
        template(v-slot:cell(auth_filemanager)="row")
          switches.lmm-switch(
            v-model="row.item.auth_filemanager",
            theme="bootstrap",
            :color="row.item.auth_filemanager ? 'warning' : 'default'",
            :disabled="true"
            @change.native="toggleChanged($event, row.item, 'auth_filemanager')"
          )
        
        template(v-slot:cell(use_approval)="row")
          switches.lmm-switch(
            v-model="row.item.use_approval",
            theme="bootstrap",
            :color="row.item.use_approval ? 'warning' : 'default'",
            :disabled="true"
            @change.native="toggleChanged($event, row.item, 'use_approval')"
          )
        
        template(v-slot:cell(post_approval)="row")
          switches.lmm-switch(
            v-model="row.item.post_approval",
            theme="bootstrap",
            :color="row.item.post_approval ? 'warning' : 'default'",
            @change.native="toggleChanged($event, row.item, 'post_approval')"
          )
        
        template(v-slot:cell(approve_seq)="row")
          span {{ approveSeq(row.item.approve_seq) }}
        
        template(v-slot:cell(work_status)="row")
          span(v-if="row.item.work_status === 1") {{$t('user_page.work')}}
          span(v-else) {{$t('user_page.resignation')}}
        
        template(v-slot:cell(flag_active)="row")
          switches.lmm-switch(
            v-model="row.item.flag_active",
            theme="bootstrap",
            :disabled="true"
            :color="row.item.flag_active ? 'warning' : 'default'",
            @input="activeChanged(row.item.pk, row.item.flag_active, row.item)"
          )

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm",
          v-model="page.per",
          :options="page.perOptions")
      b-pagination(
        size="sm",
        :total-rows="page.total",
        :per-page="page.per",
        v-model="page.current",
        class="my-0 float-right"
      )

    dialog-manager(:show.sync="showDialogManager" :userPk="parseInt(selectUserPk)" @close="closeManager")
    dialog-agent(:show.sync="showDialogAgent" :userPk="parseInt(selectUserPk)" @close="closeAgent")
</template>

<script>
import Switches from "vue-switches"
import { UsersAPI, GetMgridAPI, DepartmentsAPI, UserExcelUploadAPI } from "@/api"
import _ from "lodash"
import DialogManager from "../components/dialogManager.vue"
import DialogAgent from "../components/dialogAgent.vue"
import XLSX from "xlsx"
import { user } from "@/api/access"
import store from '@/api/store'

export default {
  name: "manager-list-component",
  components: { Switches, DialogManager, DialogAgent },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    excelUploadKey() {
      return Math.random()
    },
    accountType() {
      return store.get('auth').account_type
    },
    dynamicFields() {
      // 기본 필드
      const baseFields = [
        { key: "check", label: "", thClass: "text-center", tdClass: "text-center", sortable: false, thStyle: { width: "1%" } },
        { key: "member_type_id", label: this.$t('admin_privileges'), sortable: true, thStyle: { width: "120px" } },
        { key: "mgrid", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "120px" } },
        { key: "name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "120px" } },
        { key: "agent", label: this.$t('remote_device'), sortable: false, thStyle: { minWidth: "80px" } },
        { key: "flag_active", label: this.$t('active'), sortable: true, thStyle: { minWidth: "80px" } },
      ]
      
      // accountType 이 1일 때 추가될 필드
      if (this.accountType === 1) {
        const additionalFields = [
          { key: "part_name", label: this.$t('department'), sortable: true, thStyle: { minWidth: "120px" } },
          { key: "manager", label: this.$t('manager_str'), sortable: false, thStyle: { minWidth: "80px" } }, // 매니저 필드를 원격기기와 활성화 사이에 위치시킴
          { key: "use_approval", label: this.$t('user_page.approval_process'), sortable: true, thStyle: { minWidth: "140px" } },
          { key: "post_approval", label: this.$t('post_approval'), sortable: true, thStyle: { minWidth: "100px" } },
          { key: "approve_seq", label: this.$t('user_page.mandatory_approval_step'), sortable: true, thStyle: { minWidth: "130px" } },
        ]
        
        // "원격기기" 앞에는 "부서" 필드, 뒤에는 "매니저" 필드를 추가
        baseFields.splice(4, 0, additionalFields[0])
        baseFields.splice(6, 0, additionalFields[1])
        baseFields.push(...additionalFields.slice(2))
      }
      
      return baseFields
    },
    approveSeq() {
      return (value) => {
        if (value === 0) {
          return this.$t('user_page.not_set')
        } else if (value < 9) {
          return `${value}${this.$t('user_page.step')}`
        } else if (value === 9) {
          return this.$t('total')
        }
      }
    },
  },
  methods: {
    fetchDepartments() {
      DepartmentsAPI.get().then(res => {
        const department = res.data.objects.map(item => {
          return {
            text: item.part_name,
            value: item.part_name,
          }
        })
        _.find(this.search.options, { value: "part_name" }).select = _.concat(_.find(this.search.options, { value: "part_name" }).select, department)
      })
    },
    openDialogManager(item) {
      this.selectUserPk = item.pk
      this.showDialogManager = true
    },
    closeManager(count) {
      this.$refs[`manager-${this.selectUserPk}`].innerText = count
      this.showDialogManager = false
    },
    openDialogAgent(item) {
      this.selectUserPk = item.pk
      this.showDialogAgent = true
    },
    closeAgent(count) {
      this.$refs[`agent-${this.selectUserPk}`].innerText = count
      this.showDialogAgent = false
    },
    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },
    async fetchExcel() {
      let params = {
        by: "mgrid",
        flag_servant: true,
        limit: 0,
        offset: 0,
        order: this.search.key.order,
        search_mode: "pagination",
      }
      if (this.search.value) {
        params.search_key = this.search.key.value
        params.search_value = this.search.value
      }

      if (this.activeSelected === "active") {
        params.sort_active = "active"
      } else if (this.activeSelected === "inactive") {
        params.sort_active = "inactive"
      }

      if (params.by === "mail") {
        params.by = "email"
      }

      const list = await UsersAPI.get("", { params })
      const excelParams = list.data
      excelParams.excel_doc_title = `${this.$t('account-manage')} ${this.$t('account-manage')}`

      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "user_managerlist"
      excelParams_for_download.excel_doc_title = `${this.$t('account-manage')} ${this.$t('manage')}`

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      let output = []

      let auth_filemanager = {
        "0": "X",
        "1": "O",
      }
      let post_approval = {
        false: "X",
        true: "O",
      }
      let flag_active = {
        false: "X",
        true: "O",
      }
      let member_type_id = {
        "": this.$t('total'),
        "3": this.$t('policy_manager'),
        "2": this.$t('policy_manager'),
        "6": this.$t('mid_manager'),
        "1": this.$t('user'),
      }
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('admin_privileges')]: member_type_id[input[index]["member_type_id"]],
          [this.$t('ID')]: input[index]["mgrid"],
          "Knox ID": this.nullcheck(input[index]["knoxid"]),
          [this.$t('account-manage')]: input[index]["name"],
          [this.$t('department')]: input[index]["part_name"],
          [this.$t('user_page.designated_approver')]: this.nullcheck(input[index]["approver_name"]),
          [this.$t('manager_str')]: input[index]["dev_current"] + "/" + input[index]["dev_limit"],
          [this.$t('remote_device')]: input[index]["agent_current"] + "/" + input[index]["mgrdev_limit"],
          [this.$t('function-settings03')]: auth_filemanager[input[index]["auth_filemanager"]],
          [this.$t('post_approval')]: post_approval[input[index]["post_approval"]],
          [this.$t('user_page.mandatory_approval_step')]: input[index]["approve_seq"] + this.$t('user_page.step'),
          [this.$t('active')]: flag_active[input[index]["flag_active"]],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },

    searchHandler() {
      this.$refs.userTable.refresh()
    },
    managers(ctx) {
      if (ctx.sortBy === "") return
      this.pageMounted = false
      let params = {
        by: ctx.sortBy,
        flag_servant: true,
        limit: ctx.perPage,
        offset: (ctx.currentPage - 1) * ctx.perPage,
        order: ctx.sortDesc ? "desc" : "asc",
        search_mode: "pagination",
      }
      //this.search.key.order = params.search_key.order

      this.checkedUser = []
      if (params.by === "") return

      if (this.search.value) {
        params.search_key = this.search.key.value
        params.search_value = this.search.value
      }

      if (this.activeSelected === "active") {
        params.sort_active = "active"
      } else if (this.activeSelected === "inactive") {
        params.sort_active = "inactive"
      }

      if (params.by === "mail") {
        params.by = "email"
      }

      return UsersAPI.get("", { params }).then(res => {
        // this.sortUsersByResponse(res.data.objects)
        setTimeout(() => {
          this.pageMounted = true
        }, 300)
        this.page.total = res.data.meta.total_count
        this.allSelected = false
        this.showTableUser = res.data.objects

        this.SelectedAPI_data = res.data
        this.SelectedAPI_data.excel_doc_title = `${this.$t('account-manage')} ${this.$t('manage')}`
        //console.log(res.data)
        return res.data.objects
      })
    },
    async toggleChanged(event, item, key) {
      try {
        await UsersAPI.put(String(item.pk), { [key]: event.target.checked })
        const status = item[key]
            ? this.$t('active')
            : this.$t('inactive')
        this.$awn.success(this.$t('user_page.status_changed', {name: item.name, status: status}))
      } catch (error) {
        console.log(error)
      }
    },
    activeChanged(key, value, user) {
      if (!this.pageMounted) return
      key += ""
      let params = { flag_active: value }
      UsersAPI.put(key, params)
      let readable = value ? this.$t("active") : this.$t("inactive")
      this.$awn.success(this.$t("user_active_changed", { name: user.name, status: readable }))
    },
    remoteUser(user) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_user_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        UsersAPI.delete(`${user.pk}`).then(resp => {
          this.$awn.success(this.$t("deleted_user"))
          this.$refs.userTable.refresh()
        })
      })
    },
    checkedRemoteUser() {
      if (this.checkedUser.length === 0) {
        return this.$awn.warning(this.$t('toasts_message.select_user_to_delete'))
      }
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_checked_user_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      const usersPK = this.checkedUser.map(e => e.pk)
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        for (const user of usersPK) {
          UsersAPI.delete(user.toString()).then(resp => {
            this.$awn.success(this.$t("deleted_user"))
            this.$refs.userTable.refresh()
          })
        }
      })
    },
    setSearchKey(opt) {
      this.search.value = null
      this.search.key = opt
      if (this.search.key.type === "select") {
        this.search.value = this.search.key.select[0].value
      }
    },
    setSearchKey2(value) {
      this.search.value = null
      this.search.key = _.find(this.search.options, { value })
      if (this.search.key.type === "select") {
        this.search.value = this.search.key.select[0].value
      }
    },
    setActiveRefresh() {
      this.$refs.userTable.refresh()
    },
    handleCheck(item) {
      if (this.checkedUser.includes(item)) {
        const index = this.checkedUser.findIndex(u => u.pk === item.pk)
        this.checkedUser.splice(index, 1)
      }
      if (item.isSelected) {
        this.checkedUser.push(item)
      }
    },
    selectAllRows() {
      _.each(this.showTableUser, v => {
        v.isSelected = this.allSelected
        this.handleCheck(v)
      })
    },
    sortUsersByResponse(data) {
      data.sort((a, b) => {
        if (a.flag_active && !b.flag_active) return -1
        if (!a.flag_active && b.flag_active) return 1

        if (a.member_type_id === 6 && b.member_type_id !== 6) return -1
        if (a.member_type_id !== 6 && b.member_type_id === 6) return 1

        if (a.member_type_id !== 7 && b.member_type_id === 7) return -1
        if (a.member_type_id === 7 && b.member_type_id !== 7) return 1

        return 0 // 나머지 경우에는 순서 변경 없음
      })
    },

    async excelSubmit() {
      const header = [
        { key: "mgrid", type: "string" },
        { key: "pw", type: "string" },
        { key: "name", type: "string" },
        { key: "department", type: "department" },
        { key: "rank", type: "string" },
        { key: "position", type: "string" },
        { key: "department_leader_flag", type: "enum", enum: ["0", "1"] },
        { key: "user_type", type: "enum", enum: [this.$t('user'), this.$t('policy_manager'), this.$t('mid_manager')] },
        { key: "manage_seq", type: "number" },
        { key: "approve_seq", type: "number" },
        { key: "mgrdev_limit", type: "number" },
        { key: "dev_limit", type: "number" },
        { key: "auth_filemanager", type: "enum", enum: ["0", "1"] },
        { key: "post_approval", type: "enum", enum: ["0", "1"] },
      ]

      const departments = await DepartmentsAPI.get()
      if (departments.data.objects.length < 1) {
        this.$awn.warning(this.$t('toasts_message.no_department_info'))
        return
      }
      const partNames = _.map(departments.data.objects, "part_name")
      const input = this.$refs.excelUpload
      const reader = new FileReader()
      reader.onload = e => {
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: "binary" })
        const result = []
        let shouldBreak = false

        for (const sheetName of wb.SheetNames) {
          const rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          for (const item of rowObj) {
            const returnStr = {}

            for (const [i, key] of Object.keys(item).entries()) {
              if ((header[i].type === "string" && _.isEmpty(String(item[key]).trim())) || (header[i].type === "number" && _.isNaN(item[key]))) {
                this.$awn.warning(this.$t("required_field_message", { key: key }))
                shouldBreak = true
                break
              } else if (header[i].type === "enum" && !header[i].enum.includes(String(item[key]).trim())) {
                const keyData = key
                const values = header[i].enum.join(", ")
                this.$awn.warning(this.$t("invalid_enum_value", { key: keyData, values: values }))
                shouldBreak = true
                break
              } else if (header[i].type === "department" && !partNames.includes(String(item[key]).trim())) {
                this.$awn.warning(this.$t('toasts_message.department_name_not_found'))
                shouldBreak = true
                break
              }
              let value = header[i].type === "number" ? parseInt(String(item[key]).trim()) : String(item[key]).trim()
              returnStr[header[i].key] = value
            }
            if (shouldBreak) break
            result.push(returnStr)
          }
          if (shouldBreak) break
        }

        if (!shouldBreak) {
          if (result.length < 1) {
            this.$awn.warning(this.$t('toasts_message.excel_no_data'))
            return
          }
          var itemList = JSON.stringify(result)
          UserExcelUploadAPI.post("", itemList)
            .then(resp => {
              let total = resp.data.objects.total_count
              let failure = resp.data.objects.failed_count
              this.$awn.success(this.$t("excel_user_submit", { total, failure }))
              this.addBulk = false
              this.$refs.userTable.refresh()
            })
            .catch(e => {
              console.log(e)
            })
        }
      }
      if (input.files[0]) {
        reader.readAsBinaryString(input.files[0])
      } else {
        this.$awn.warning(this.$t('toasts_message.select_file'))
      }
    },
  },
  mounted() {
    this.fetchDepartments()
  },
  data() {
    return {
      user: user(),
      Form: `${this.AppState.Path.download}/form`,
      selectUserPk: 0,
      showDialogManager: false,
      showDialogAgent: false,

      pageMounted: false,
      sortActiveFlag: false,
      checkedUser: [],
      allSelected: false,
      showTableUser: [],
      excelLoaded: false,
      excelLink: null,

      addBulk: false,
      
      page: {
        total: 0,
        current: 1,
        per: 24,
        perOptions: [
          { value: 5, text: "5" },
          { value: 12, text: "12" },
          { value: 24, text: "24" },
          { value: 36, text: "36" },
        ],
      },
      search: {
        val: "member_type_id",
        key: {
          value: "member_type_id",
          text: this.$t('admin_privileges'),
          type: "select",
          select: [
            { value: "", text: this.$t('total') },
            { value: "3", text: this.$t('policy_manager') },
            { value: "6", text: this.$t('mid_manager') },
            { value: "1", text: this.$t('user') },
          ],
        },
        options: [
          {
            value: "member_type_id",
            text: this.$t('admin_privileges'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "3", text: this.$t('policy_manager') },
              { value: "6", text: this.$t('mid_manager') },
              { value: "1", text: this.$t('user') },
            ],
          },
          { value: "mgrid", text: this.$t('ID'), type: "keyword" },
          { value: "name", text: this.$t('account-manage'), type: "keyword" },
          {
            value: "part_name",
            text: this.$t('department'),
            type: "select",
            select: [{ value: "", text: this.$t('total') }],
          },
          // { value: "approver_name", text: "지정 결재자", type: "keyword" },
          { value: "dev_current", text: `${this.$t('manager_str')}(${this.$t('dialogs_page.current_registration')})`, type: "number" },
          { value: "mgrdev_limit", text: `${this.$t('manager_str')}(${this.$t('user_page.registration_limit')})`, type: "number" },
          { value: "agent_current", text: `${this.$t('device')}(${this.$t('dialogs_page.current_registration')})`, type: "number" },
          { value: "dev_limit", text: `${this.$t('device')}(${this.$t('user_page.registration_limit')})`, type: "number" },
          {
            value: "auth_filemanager",
            text: this.$t('function-settings03'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "1", text: "O" },
              { value: "0", text: "X" },
            ],
          },
          {
            value: "use_approval",
            text: this.$t('user_page.approval_process'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "1", text: "O" },
              { value: "0", text: "X" },
            ],
          },
          {
            value: "post_approval",
            text: this.$t('post_approval'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "1", text: "O" },
              { value: "0", text: "X" },
            ],
          },
          {
            value: "approve_seq",
            text: this.$t('user_page.mandatory_approval_step'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "1", text: `1${this.$t('step')}` },
              { value: "2", text: `2${this.$t('step')}` },
              { value: "3", text: `3${this.$t('step')}` },
              { value: "4", text: `4${this.$t('step')}` },
            ],
          },
          {
            value: "flag_active",
            text: this.$t('active'),
            type: "select",
            select: [
              { value: "", text: this.$t('total') },
              { value: "1", text: this.$t("active") },
              { value: "0", text: this.$t("inactive") },
            ],
          },
        ],
        value: "",
      },
      activeSelected: null,
      dropdownActive: [
        { value: "active", text: this.$t("active") },
        { value: "inactive", text: this.$t("inactive") },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.delete-btn {
  background-color: #ec7211 !important;
  color: #ffffff !important;
  border: 1px solid #e96700 !important;
  font-weight: 400;
  &:hover {
    background-color: #e96700 !important;
    color: #ffffff !important;
    border: 1px solid #e96700 !important;
    font-weight: 400;
  }
}

.btn-link {
  padding: 0.41rem 0.75rem 0.41rem 0;
  font-size: 14px;
}

svg {
  color: #ababab;
}
em {
  font-style: normal;
}
</style>